import React, { Fragment, useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { UTILS } from "utils";
//Todo: remove the commented code and related files
// import SignIn from "../../features/auth/containers/Signin";
// import Register from "../../features/register/container/Register";
// import ForgotPassword from "features/auth/containers/ForgotPassword";
// import NewPassword from "features/auth/containers/newPassword";
import Dashboard from "features/dashboard/container/index";

import Login from "features/auth/screens/login";
import AccountRegistration from "features/auth/screens/account-registration";
import ForgotPassword from "features/auth/screens/forgot-password";
import ResetPassword from "features/auth/screens/reset-password";

export const authRoutesUrls = {
  login: "/Login",
  forgotPassword: "/forgotpassword",
  newPassword: "/newpassword",
  register: "/register",
  dashboard: "/app/dashboard",
  verify: "/verify/validate-otp",
};

function PublicRoutes() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  let history = useHistory();
  useEffect(() => {
    const userDetail = UTILS.getCurrentUser();
    if (userDetail?.token) {
      setIsLoggedIn(true);
      history.push("/app/dashboard");
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const authRoutes = [
    {
      path: authRoutesUrls.login,
      component: Login,
    },
    {
      path: authRoutesUrls.forgotPassword,
      component: ForgotPassword,
    },
    {
      path: authRoutesUrls.newPassword,
      component: ResetPassword,
    },
    {
      path: authRoutesUrls.dashboard,
      component: Dashboard,
    },
  ];
  return (
    <Fragment>
      <Switch>
        {authRoutes.map((route, index) => {
          return (
            <Route
              key={index}
              path={route.path}
              exact
              component={route.component}
            />
          );
        })}

        {!isLoggedIn && (
          <Route exact path={authRoutesUrls.register}>
            <AccountRegistration />
          </Route>
        )}
        <Route path="">
          <Login />
        </Route>
      </Switch>
    </Fragment>
  );
}

export default PublicRoutes;
